import React, { useState, useRef, useEffect } from 'react';
import { RxCaretDown } from "react-icons/rx";
import { FiChevronRight } from "react-icons/fi";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { Grid, Cell } from 'react-md';
import ApiRequestService from '../../components/ApiRequestService';
import "./style.css";
import { BeatLoader } from 'react-spinners';

const colors = [
    "bg-blue-500",
    "bg-green-500",
    "bg-pink-500",
    "bg-purple-500",
    "bg-orange-500",
    "bg-red-500",
    "bg-teal-500",
    "bg-yellow-500",
    "bg-indigo-500",
    "bg-cyan-500",
    "bg-lime-500",
    "bg-emerald-500",
    "bg-fuchsia-500",
    "bg-rose-500",
    "bg-sky-500",
    "bg-violet-500",
    "bg-amber-500",
    "bg-stone-500",
    "bg-gray-500",
    "bg-slate-500",
];

const SFPublicSkillsLibrary = ({ show = false }) => {

    const [open, setOpen] = useState(show);
    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState("all");
    const [skills, setSkills] = useState([]);
    const [filteredSkills, setFilteredSkills] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [allExpanded, setAllExpanded] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (show) {
            setOpen(true);
        }
    }, [show])

    useEffect(() => {
        if (open) {
            setSelectedSection("all");
            getPublicAssignments();
        }
    }, [open])

    const getPublicAssignments = () => {
        setLoading(true);
        ApiRequestService({
            method: 'GET',
            url: '/getPublicAssignments'
        }).then(res => {
            if (res && res.data && res.data.data) {
                let tempSections = res.data.data;
                let allAssignments = [];
                tempSections.forEach(section => {
                    if (section && section.assignments) {
                        let sectionAssignments = section.assignments.map(assign => {
                            return {
                                ...assign,
                                expand: false,
                                section_id: section.section_id,
                            }
                        })
                        allAssignments.push(...sectionAssignments);
                    }
                })
                console.debug("tempSections>>??", tempSections);
                setSections(tempSections);
                setSkills(allAssignments);
                setFilteredSkills(allAssignments);
            } else {
                setSkills([]);
                setSections([]);
                setFilteredSkills([]);
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    const handleExpandAllSkills = () => {
        setAllExpanded(true);

        let tempAllSkills = skills.map(assign => {
            return {
                ...assign,
                expand: true
            }
        });
        setSkills(tempAllSkills);


        let tempFilteredSkills = filteredSkills.map(assign => {
            return {
                ...assign,
                expand: true
            }
        });
        setFilteredSkills(tempFilteredSkills);
    }

    const handleCollapseAllSkills = () => {
        setAllExpanded(false);
        let tempAllSkills = skills.map(assign => {
            return {
                ...assign,
                expand: false
            }
        });
        setSkills(tempAllSkills);

        let tempFilteredSkills = filteredSkills.map(assign => {
            return {
                ...assign,
                expand: false
            }
        });
        setFilteredSkills(tempFilteredSkills);
    }

    return (
        <div>
            {/* <Button variant='contained' onClick={() => setOpen(true)}>
                Skills Library
            </Button> */}
            <button className="brilliant-btn" onClick={() => setOpen(true)}>
                Skills Library
            </button>
            <Dialog open={open} onClose={() => setOpen(false)}
                maxWidth="xl"
                // fullScreen
                fullWidth
            >
                <DialogTitle>
                    <h3>Skills Library</h3>
                    <div className='fontClass-14'>Pick any skill you want and start practicing!</div>
                </DialogTitle>
                <DialogContent className='dialog-container'>
                    <div className="mb-3">
                        {loading ?
                            <center>
                                <BeatLoader loading={loading} color='#bb0000' />
                                <div className='text-secondary'>Fetching Skills</div>
                            </center>
                            :
                            <section className='section-style'>
                                <Grid>
                                    <Cell size={2} desktopSize={2} tabletSize={12} phoneSize={12}>
                                        <div className='custom-container'>
                                            <div className={`list-btn 
                            ${selectedSection === "all" ? "list-btn-selected" : ''}`}
                                                onClick={() => {
                                                    setSelectedSection("all");
                                                    setFilteredSkills(skills);
                                                }}
                                            >All</div>
                                            {sections && sections.length ?
                                                sections.map((section, sectionIndex) => {
                                                    let className = "list-btn";
                                                    if (selectedSection !== "all" && selectedSection === section.section_id) {
                                                        className += " list-btn-selected"
                                                    }
                                                    return <div className={className}
                                                        key={sectionIndex}
                                                        onClick={() => {
                                                            setSelectedSection(section.section_id);
                                                            let tempFilteredSkills = skills.filter(assign => assign.section_id === section.section_id);
                                                            setFilteredSkills(tempFilteredSkills);
                                                        }}>
                                                        {section.section_name}
                                                    </div>
                                                })
                                                : null}
                                        </div>
                                    </Cell>

                                    <Cell size={10} tabletSize={12} phoneSize={12}>
                                        <div className='my-2'>
                                            <div className='d-flex flex-wrap justify-content-between'>
                                                <div className='w-full'>
                                                    <TextField
                                                        placeholder='Search by skills'
                                                        className='search-skills pb-2'
                                                        fullWidth
                                                        value={searchText}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '8px',
                                                            },
                                                        }}
                                                        size='small'
                                                        onChange={e => {
                                                            setSearchText(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className='flex gap-2 justify-center items-center'>
                                                    {allExpanded ?
                                                        <Button className='expand-btn' onClick={handleCollapseAllSkills}>
                                                            <RxCaretDown fontSize={26} color='#333' className='rotate-180' />
                                                            Collapse All
                                                        </Button>
                                                        :
                                                        <Button className='expand-btn' onClick={handleExpandAllSkills}>
                                                            <RxCaretDown fontSize={26} color='#333' />
                                                            Expand All
                                                        </Button>
                                                    }
                                                </div>
                                            </div>
                                            <div className='skills-container'>
                                                <Grid className='px-0'>
                                                    {filteredSkills && filteredSkills.filter(assign => assign.quiz_name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())).length > 0
                                                        ? filteredSkills
                                                            .filter(assign => assign.quiz_name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()))
                                                            .map((assignment, assignIndex) => {

                                                                let description = "Get ready to practice and strengthen your skills with this quiz!";
                                                                if (assignment.splash_screen !== `<p dir="auto" style=""><br></p>`) {
                                                                    description = assignment.splash_screen;
                                                                }

                                                                let bgColor = colors[assignIndex % colors.length];
                                                                let textColor = "text-white";
                                                                bgColor = 'bg-gray-400';
                                                                textColor = 'text-gray-700';
                                                                return (
                                                                    <Cell size={3} tabletSize={6} phoneSize={12}>
                                                                        <SkillAccordion
                                                                            title={assignment?.quiz_name}
                                                                            description={
                                                                                <div className={`mb-2 text-gray-700`}
                                                                                    dangerouslySetInnerHTML={{ __html: description }}
                                                                                />
                                                                            }
                                                                            defaultExpand={assignment?.expand}
                                                                            assignment={assignment}
                                                                        />
                                                                    </Cell>
                                                                );
                                                            })
                                                        : (
                                                            <div className='w-full col-span-full py-4 text-gray-700'>
                                                                <center>
                                                                    {searchText
                                                                        ? `No assignments found for "${searchText}".`
                                                                        : "No assignments."
                                                                    }
                                                                </center>
                                                            </div>

                                                        )
                                                    }
                                                </Grid>
                                            </div>
                                        </div>
                                    </Cell>
                                </Grid>


                            </section>
                        }

                    </div>

                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={() => setOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}


const SkillAccordion = ({ title, description, defaultExpand, assignment, bgColor, textColor }) => {
    const [expand, setExpand] = useState(false);
    const [height, setHeight] = useState(0);
    const contentRef = useRef(null);

    useEffect(() => {
        handleExpand(defaultExpand);
    }, [defaultExpand]);

    const handleExpand = (val) => {
        if (val) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
        setExpand(val);
    };

    const handleStartPracticeSkill = () => {
        let studentRegistrationSiteURL = "";
        if (window.location.hostname === "localhost") {
            studentRegistrationSiteURL = "http://localhost:3001";
        } else {
            studentRegistrationSiteURL = window.location.origin;
        }

        let studentAssignmentURL = `${studentRegistrationSiteURL}/takequiz?quiz_id=${assignment.quiz_id}&course_id=${assignment.course_id}&section_id=${assignment.section_id}&quiz_name=${assignment.quiz_name}&quiz_type=${assignment.quiz_type}&course_name=${assignment.course_name}`;
        console.debug("studentAssignmentURL>>??", studentAssignmentURL, assignment);

        // window.location.href = studentAssignmentURL;
        window.location.replace(studentAssignmentURL);
    }

    return (
        <div className="sa-container">
            <div
                className={`sa-header ${bgColor} ${textColor}`}
                onClick={() => handleExpand(!expand)}
            >
                <div className="sa-title">
                    {title}
                </div>

                <div className={`sa-icon ${expand ? "sa-icon-expanded" : ""}`}>
                    <RxCaretDown fontSize={32} />
                </div>
            </div>

            <div
                ref={contentRef}
                style={{ maxHeight: height }}
                className={`sa-content-outer ${expand ? "sa-content-open" : ""}`}
            >
                <div className={`sa-content-inner ${expand ? "sa-content-visible" : ""}`}>
                    {description}
                </div>
            </div>

            <div className="sa-footer">
                <button
                    className="start-practice-btn"
                    onClick={handleStartPracticeSkill}
                >
                    <span className="start-practice-text">Start Practice</span>
                    <FiChevronRight className="start-practice-icon" />
                </button>
            </div>
        </div>
    );
};


export default SFPublicSkillsLibrary;

